// extracted by mini-css-extract-plugin
export var animating = "_redotech-redo-web-src-dropdown-animating";
export var background = "_redotech-redo-web-src-dropdown-background";
export var constrainHeight = "_redotech-redo-web-src-dropdown-constrain-height";
export var dark = "_redotech-redo-web-src-dropdown-dark";
export var dropdown = "_redotech-redo-web-src-dropdown-dropdown";
export var leave = "_redotech-redo-web-src-dropdown-leave";
export var option = "_redotech-redo-web-src-dropdown-option";
export var root = "_redotech-redo-web-src-dropdown-root";